import StatisticChart from './StatisticChart'

export default StatisticChart
